export default __webpack_public_path__ + "static/media/location.6bf94321.svg";